import React, {useEffect, useState} from 'react';
import {
  Box,
  Button,
  List,
  ListItem,
  Typography,
  Tooltip,
  FormHelperText,
} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import {useDropzone} from 'react-dropzone';
import ViewIcon from '@material-ui/icons/Visibility';
import {useSelector} from 'react-redux';

const useStyles = makeStyles((theme) => ({
  boxDrop: {
    padding: '2px 0px 0px 0px',
  },
  previewImg: {
    maxHeight: '1122px !important',
    maxWidth: '794px !important',
    height: 'auto',
    width: 'auto',
  },
  fileText: {
    margin: '10px 0 0',
    fontSize: '12px',
    fontWeight: 700,
    color: '#000000',
  },
  extendedIcon: {
    marginRight: theme.spacing(3),
    marginBottom: '7px',
  },
  uploadText: {
    fontSize: '17px !important',
    paddingTop: '10px',
    [theme.breakpoints.down('md')]: {
      fontSize: '13px !important',
    },
  },
  uploadContent: {
    fontSize: '17px !important',
    paddingBottom: '10px',
    [theme.breakpoints.down('md')]: {
      fontSize: '13px !important',
    },
  },
  filePara: {
    textAlign: 'center !important',
    marginTop: '15px !important',
  },
  actionButton: {
    textTransform: 'capitalize',
    fontSize: '0.9rem',
    color: '#6418c3',
    fontWeight: 600,
    padding: '5px 30px 5px 30px',
    borderRadius: '5px',
    backgroundColor: 'transparent',
    outline: 'none',
    border: '2px solid #6418c3',
    [theme.breakpoints.down('md')]: {
      fontSize: '13px',
      marginTop: '10px',
    },
  },
  documentText: {
    fontWeight: '600 ',
    fontSize: '15px ',
    cursor: 'pointer ',
    padding: '10px 5px',
    textAlign: 'center',
    color: '#6418c3',
  },
}));

const DragAndDrop = ({
  selectedFile,
  setSelectedFile,
  userSelectedTemplateType,
  setFieldValue,
  error,
  fileValid,
  helperText,
  uploadedFile,
  addHospital,
  setFileValid,
  logoFile,
  capturedImages,
  fileSizeError,
  setFileSizeError,
  oldFile,
  viewhandler,
  viewIconCond,
  setFilePathName,
}) => {
  const classes = useStyles();
  const [files, setFiles] = useState('');
  const [filePath, setFilePath] = useState(false);
  const {communicationDetails} = useSelector(({commmunicaionLetter}) => commmunicaionLetter);

  const {getRootProps, getInputProps, open, acceptedFiles} = useDropzone({
    // Disable click and keydown behavior
    noClick: true,
    noKeyboard: true,
    multiple: false,
    accept: '',
    onDrop: (acceptedFiles) => {
      setFileValid(acceptedFiles[0]?.size > 5242880);
      setSelectedFile(acceptedFiles);
    },
  });

  useEffect(() => {
    if (uploadedFile == null) {
      acceptedFiles.splice(0, 1);
      setFiles([]);
    }
  }, [uploadedFile]);

  useEffect(() => {
    if (selectedFile == '') {
      setFiles('');
    }
  }, [selectedFile, files]);

  useEffect(() => {
    if (acceptedFiles.length > 0) {
      const files = acceptedFiles.map((file, i) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {};
        const remove = (file) => {
          acceptedFiles.splice(file, 1);
          setFiles([]);
        };
        return (
          <ListItem key={file.path}>
            <span
              role="button"
              tabIndex={0}
              style={{cursor: 'pointer'}}
              onClick={() => viewhandler()}
            >
              {file.path}
            </span>
            <Tooltip title="Delete">
              <DeleteRoundedIcon
                style={{cursor: 'pointer'}}
                onClick={() => {
                  remove(i);
                }}
              />
            </Tooltip>
          </ListItem>
        );
      });
      setFiles(files);
    } else if (oldFile.length > 0 && !oldFile.includes('')) {
      const files = oldFile.map((file, i) => {
        const remove = (file) => {
          oldFile.splice(file, 1);
          setFiles([]);
        };
        return (
          <ListItem key={file}>
            <span
              role="button"
              tabIndex={0}
              style={{cursor: 'pointer'}}
              onClick={() => viewhandler()}
            >
              {i + 1}.{file}
            </span>
            <Tooltip title="Delete">
              <DeleteRoundedIcon style={{cursor: 'pointer'}} onClick={() => remove(i)} />
            </Tooltip>
          </ListItem>
        );
      });
      setFiles(files);
    }
  }, [acceptedFiles, setFieldValue, oldFile]);
  return (
    <>
      <Box className={classes.boxDrop}>
        <div className={`d-flex flex-row align-items-center`}>
          <Box {...getRootProps({className: 'dropzone d-flex flex-row justify-content-around'})}>
            <input {...getInputProps()} />
            <Typography className={classes.uploadText}>Drag and drop file here</Typography>
            <Typography className={classes.uploadContent}>Or</Typography>
            <Button
              variant="outlined"
              disabled={capturedImages && capturedImages.length}
              onClick={() => {
                open();
                setFilePath(true);
              }}
              className={classes.actionButton}
            >
              Browse
            </Button>
            {error && (
              <b className="text-danger mt-2">
                <p>{helperText}</p>
              </b>
            )}
            {viewIconCond ? (
              <Tooltip title="View">
                <ViewIcon
                  style={{
                    cursor: 'pointer',
                    margin: '0px 10px 0 12px',
                  }}
                  onClick={() => viewhandler()}
                />
              </Tooltip>
            ) : (
              ''
            )}
          </Box>
        </div>
        <aside style={{marginLeft: '17px'}}>
          {fileValid ? (
            <FormHelperText style={{color: 'red'}} variant="outlined">
              File size cannot exceed 5MB
            </FormHelperText>
          ) : (
            ''
          )}
        </aside>
        <aside>
          <List className={classes.documentText}>
            {!fileValid && files}{' '}
            {Object.keys(communicationDetails).length > 0 &&
            communicationDetails?.fileName &&
            viewIconCond &&
            !filePath ? (
                <span role="button" tabIndex={0} onClick={() => viewhandler()}>
                  {communicationDetails?.fileName}{' '}
                </span>
              ) : (
                ''
              )}
          </List>
        </aside>
      </Box>
    </>
  );
};

export default DragAndDrop;
